const handleScrollItonView = () => {
  try {
    document.getElementById('headersteped').scrollIntoView()
  } catch (error) {
    console.log(error)
  }
}

export default handleScrollItonView
